import request from "@/router/axios"
export const add = (data) => {
    return request({
        url: `/api/jc/resource/distance/add`,
        method: 'post',
        data: data
    })
}
export const edit = (data) => {
    return request({
        url: `/api/jc/resource/distance/edit`,
        method: 'post',
        data: data
    })
}